/**
 * @author LiuMing
 * @description 二进制流导出文件
 * @param {Blob} data 文件二进制流
 * @param {*} headers 响应头
 * @param {String} name 文件名
 */
export const exportFile = (data, headers, name) => {
  const fileReader = new FileReader();
  fileReader.onload = function () {
    // 下载正常处理
    let fileName = headers["content-disposition"];

    // 获取文件名
    if (fileName && fileName.length >= 2) {
      fileName = fileName.split("=")[1];
    }
    // fileName = decodeURIComponent(fileName);
    // 自定义
    fileName = decodeURIComponent(`${name}.xls`);

    // 兼容ie11
    if (window.navigator.msSaveOrOpenBlob) {
      try {
        const blobObject = new Blob([data]);
        window.navigator.msSaveOrOpenBlob(blobObject, fileName);
      } catch (e) {

      }
      return;
    }
    // a标签实现下载
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  };
  fileReader.readAsText(data); // FileReader的API
}
